import React, { useCallback } from 'react';
import { BsCreditCard, BsEye } from 'react-icons/bs';
import { AnimatedContainer, ButtonLoadingForm } from '../styles';
import { StepIndicator } from '../components/StepIndicator';
import { ComponentUserRegisterProps, stepLabels } from '..';
import {
  ActionContainer,
  BenefitsContainer,
  ButtonConfirmForm,
  InfoContainer,
  LabelContainer,
  LineSeparator,
  LinkContainer,
  MonthPriceWrapper,
  OptionsContainer,
  PaymentOptionWrapper,
  PriceContainer,
  PriceItem,
  SubscriptionContainer,
  SubscriptionContent,
  TotalPriceWrapper,
} from './styles';
import watch from '../../../assets/watch.svg';
import { PaymentMethodEnum } from '../../../enums/PaymentMethodEnum';
import { useUser } from '../../../hooks/user';
import { Subscriber } from '../../../entities/Subscriber';
import PixIcon from '../../../assets/pix-icon.svg';

export const Payment: React.FC<ComponentUserRegisterProps> = ({
  handleScreenSelection,
  nextPage,
}) => {
  const { setUser, user } = useUser();

  const handlePaymentSelection = useCallback(
    (paymentMethod: PaymentMethodEnum) => {
      setUser((prev: Subscriber) => ({
        ...prev,
        paymentMethod,
      }));

      handleScreenSelection(paymentMethod);
      nextPage();
    },
    [setUser, nextPage, handleScreenSelection],
  );

  return (
    <AnimatedContainer>
      <StepIndicator activeIndex={3} titles={stepLabels} />
      <h1>Pagamento</h1>
      <InfoContainer>
        <span>Como funciona a assinatura?</span>
        <LinkContainer>
          <BsEye size={16} />
          <span>Contrato de prestação de serviços</span>
        </LinkContainer>
      </InfoContainer>
      <SubscriptionContainer>
        <img src={watch} alt="watch" />
        <SubscriptionContent>
          <h1>Assistente Virtual</h1>
          <PriceContainer>
            <PriceItem>
              <TotalPriceWrapper>
                <div className="priceSection">
                  <span>R$ 290,00 no Cartão/Pix</span>
                </div>
              </TotalPriceWrapper>
              <MonthPriceWrapper>
                <span>
                  R$ 40,00 Mensais{' '}
                  <span className="additionalPrice">+ R$ 205,00</span>
                </span>
              </MonthPriceWrapper>
            </PriceItem>
          </PriceContainer>
          <LineSeparator />
          <h2>Benefícios</h2>
          <BenefitsContainer>
            <div>
              <span>Pulseira inteligente</span>
            </div>
            <div>
              <span>Relatórios de Saúde na palma da mão</span>
            </div>
            <div>
              <span>Aplicativo com Assistente Virtual integrado </span>
            </div>
            <div>
              <span>Acompanhamento com Profissionais da Saúde</span>
            </div>
          </BenefitsContainer>
        </SubscriptionContent>
      </SubscriptionContainer>
      <OptionsContainer>
        <p>Escolha uma forma de pagamento:</p>
        <PaymentOptionWrapper
          isSelected={user?.paymentMethod === PaymentMethodEnum.CreditCard}
          onClick={() => handlePaymentSelection(PaymentMethodEnum.CreditCard)}
        >
          <LabelContainer
            isSelected={user?.paymentMethod === PaymentMethodEnum.CreditCard}
          >
            <BsCreditCard size={22} />
            <span>Cartão de crédito</span>
          </LabelContainer>
          <ActionContainer>
            <span>
              {user?.paymentMethod === PaymentMethodEnum.CreditCard
                ? 'Selecionado'
                : 'Selecionar'}
            </span>
          </ActionContainer>
        </PaymentOptionWrapper>
        <PaymentOptionWrapper
          isSelected={user?.paymentMethod === PaymentMethodEnum.Pix}
          onClick={() => handlePaymentSelection(PaymentMethodEnum.Pix)}
        >
          <LabelContainer
            isSelected={user?.paymentMethod === PaymentMethodEnum.Pix}
          >
            <img src={PixIcon} alt="Pix" />
            <span>Pix</span>
          </LabelContainer>
          <ActionContainer>
            <span>
              {user?.paymentMethod === PaymentMethodEnum.Pix
                ? 'Selecionado'
                : 'Selecionar'}
            </span>
          </ActionContainer>
        </PaymentOptionWrapper>
      </OptionsContainer>
      {user?.paymentMethod && (
        <ButtonConfirmForm
          onClick={() => handlePaymentSelection(user.paymentMethod)}
          isLoading={false}
        >
          Confirmar
        </ButtonConfirmForm>
      )}
    </AnimatedContainer>
  );
};
